// extracted by mini-css-extract-plugin
module.exports = {"page":"ConsentsPage_page__BCBT9","title":"ConsentsPage_title__2nm97"};